export const membershipMonthlyEquivalentAmount = (membership) => {
	const amount = parseFloat(membership && membership.cost_per_month);
	if (!Number.isFinite(amount)) {
		return 0;
	}

	return membership && membership.billing_period === "yearly" ? amount / 12 : amount;
};

export const membershipHasFailedBilling = (membership) => (
	String((membership && membership.last_billing_status) || "").toLowerCase() === "failed"
	|| (parseInt(membership && membership.failed_billing_count, 10) || 0) > 0
);

export const membershipMonthlyValue = (memberships) => (
	(memberships || []).reduce((total, membership) => total + membershipMonthlyEquivalentAmount(membership), 0)
);

export const resolvedAccountMembershipMonthlyValue = (accountMonthlyValue, fallbackMemberships) => {
	const amount = parseFloat(accountMonthlyValue);
	return Number.isFinite(amount) ? amount : membershipMonthlyValue(fallbackMemberships);
};
